/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disabled no-mixed-spaces-and-tabs */

import { IBEError } from '@common/interfaces/be-error.interface';
import { CustomAxiosResponse } from '@common/interfaces/custom-axios-response.interface';
import { CustomPromise } from '@common/interfaces/custom-promise.interface';
import { IRequestService, requestService } from '@common/services/request.service';
import { formatUrl } from '@common/utils/format-url.util';
import { BE_API_URLS } from '@src/shared/be-api-urls.constant';

const API_SERVER_URL = BE_API_URLS.utilService.apiUrl;

// DON'T REMOVE THIS COMMENTS!!! Code between comments auto-generated
// INSERT START
export type TIntegrationV1UtilsReferralCouponSharingGetError = '' | 'InvalidQueryParams';
export type TPartialErrorCodes = TIntegrationV1UtilsReferralCouponSharingGetError | '';

export const createApiRequest = (rs: IRequestService) => ({
    // build HTML for referral coupon sharing
    integrationV1UtilsReferralCouponSharingGet: (
        query: { title?: string; description?: string; redirect_url?: string } | undefined,
    ): CustomPromise<
        CustomAxiosResponse<void, TIntegrationV1UtilsReferralCouponSharingGetError>,
        IBEError<TIntegrationV1UtilsReferralCouponSharingGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/integration/api/v1/utils/referral_coupon/sharing`, query)),
});

const URL = {
    integrationV1UtilsReferralCouponSharingGet: (): string => `/integration/api/v1/utils/referral_coupon/sharing`,
};
// INSERT END
// DON'T REMOVE THIS COMMENTS!!!

export const utilApiRequest = {
    ...createApiRequest(requestService),
};
export const UTIL_API_URL = URL;
export type IUtilApiRequest = Partial<typeof utilApiRequest>;
